import React from 'react'

function TechArticle() {
  return (
    <embed src="\pdfs\technical-article-firing-range-2014-03.pdf" width="100%" height="2100px" />
  )
}

export default TechArticle